import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "bulkButton"]

  connect() {
    this.updateButtonState()
  }

  toggleAll(event) {
    const isChecked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateButtonState()
  }

  toggleCheckbox() {
    const allChecked = this.checkboxTargets.length > 0 &&
                       this.checkboxTargets.every(cb => cb.checked)
    const someChecked = this.checkboxTargets.some(cb => cb.checked)

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = allChecked
      this.selectAllTarget.indeterminate = someChecked && !allChecked
    }

    this.updateButtonState()
  }

  updateButtonState() {
    if (this.hasBulkButtonTarget) {
      const anyChecked = this.checkboxTargets.some(cb => cb.checked)
      this.bulkButtonTarget.disabled = !anyChecked
    }
  }

  bulkRemove() {
    const selectedOrderIds = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.orderId)

    if (selectedOrderIds.length === 0) {
      alert("Please select at least one order")
      return
    }

    const paymentJournalId = this.bulkButtonTarget.dataset.paymentJournalId
    const confirmMessage = `Remove payment hold for ${selectedOrderIds.length} order(s)?`

    if (!confirm(confirmMessage)) {
      return
    }

    // Create and submit a form
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `/payment_journals/${paymentJournalId}/bulk_disable_payment_hold`

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    // Add method override for PUT
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'put'
    form.appendChild(methodInput)

    // Add order IDs
    const orderIdsInput = document.createElement('input')
    orderIdsInput.type = 'hidden'
    orderIdsInput.name = 'order_ids'
    orderIdsInput.value = selectedOrderIds.join(',')
    form.appendChild(orderIdsInput)

    document.body.appendChild(form)
    form.submit()
  }
}
